import React, { ChangeEventHandler, ReactElement } from 'react';
import styles from '../consumer-review-dialog.module.scss';
import { Text } from '@dotcom/crown-ui';

type ConsumerReviewCheckProps = {
  isConsumerReviewChecked: boolean;
  onCheckboxChange: ChangeEventHandler<HTMLInputElement>;
  checkboxLabel: string;
};

export const ConsumerReviewCheck = ({
  checkboxLabel,
  isConsumerReviewChecked,
  onCheckboxChange,
}: ConsumerReviewCheckProps): ReactElement => (
  <div className={styles['consumer-description-container']}>
    <input
      type="checkbox"
      id="acknowledge-checkbox"
      className={styles['consumer-review-checkbox']}
      data-testid="consumer-review-checkbox"
      checked={isConsumerReviewChecked}
      onChange={onCheckboxChange}
    />
    <Text as="label" htmlFor="acknowledge-checkbox">
      {checkboxLabel}
    </Text>
  </div>
);
